// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"66ab4539","488":"996c6a8c"}[chunkId] + ".chunk.js";
};